import React, { useContext } from 'react'
import classNames from 'classnames'
import { DepartmentIcon, Logo } from '@deal/components'
import { DepartmentContext } from '#src/context/department'
import { NavLink } from 'react-router-dom'
import BrandAwareLogo from '#src/components/Logo'
import styles from './styles.css'

interface LogoProps {
  className?: string
  showIconMark?: boolean
  showDepartment?: boolean
}

const HeaderLogo: React.FC<LogoProps> = ({
  showIconMark = true,
  showDepartment = true,
  className
}) => {
  const { department } = useContext(DepartmentContext)

  return (
    <NavLink to={department ? `/d/${department.slug}` : '/'} className={styles.link}>
      {showIconMark && (
        <>
          {department ? (
            <DepartmentIcon departmentSlug={department.slug} className={styles.departmentIcon} />
          ) : (
            <Logo className={styles.logoIcon} mark="icon" />
          )}
        </>
      )}

      <div className={styles.stack}>
        <BrandAwareLogo color="dark" className={classNames(styles.wordmark, className)} />
        {showDepartment && department && (
          <div className={styles.departmentName}>{department.displayName}</div>
        )}
      </div>
    </NavLink>
  )
}

export default HeaderLogo
